<template>
  <div id="config-automations-wrapper">
    <item-tile
      v-for="(item, index) in automations"
      :key="index"
      class="automation-item"
      :heading="item.title"
      :selected="true"
      :secondaryIcons="['pencil']"
      @primary-icon-clicked="initiateDelete(item, index)"
      @secondary-icon-clicked="initiateEdit(item, index)"
    />
    <item-tile
      class="automation-item"
      :selected="false"
      heading="Add New Automation"
      @click="toggleCreationActive"
    />
    <automation-creation
      v-if="creationActive"
      :automation="edit.automation"
      @close="toggleCreationActive"
      @add-automation="callDb"
    />
    <automation-delete
      v-if="del.automation"
      :subject="del.automation"
      :processing="del.processing"
      @close="closeDelete"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import AutomationCreation from "./Modals/Automations/AutomationCreation.vue";
import AutomationDelete from "./Modals/Automations/Delete.vue";
import ItemTile from "@/Components/UI/ItemTile.vue";
export default {
  data() {
    return {
      creationActive: false,
      deleteActive: false,
      edit: {
        processing: false,
        automation: undefined,
        index: undefined,
      },
      del: {
        processing: false,
        automation: undefined,
        index: undefined,
      },
    };
  },
  computed: {
    automations() {
      return this.$store.getters.automations;
    },
  },
  methods: {
    toggleCreationActive() {
      this.creationActive = !this.creationActive;
    },
    initiateEdit(item, index) {
      this.edit.automation = item;
      this.edit.index = index;
      this.toggleCreationActive();
    },
    initiateDelete(item, index) {
      this.del.automation = item;
      this.del.index = index;
    },
    closeDelete() {
      this.del = {
        processing: false,
        automation: undefined,
        index: undefined,
      };
    },
    async confirmDelete() {
      this.del.processing = true;
      await this.$store.dispatch("updateConfig", {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        index: this.del.index,
        category: "automations",
        operation: "delete",
        api_version: this.$store.state.businessSettings.api_version,
      });
      this.closeDelete();
    },
    async callDb(subject) {
      let updatePacket = {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        subject: subject,
        category: "automations",
        api_version: this.$store.state.businessSettings.api_version,
      };
      if (this.edit.index !== undefined) {
        updatePacket = {
          ...updatePacket,
          operation: "edit",
          index: this.edit.index,
        };
      } else {
        updatePacket = {
          ...updatePacket,
          operation: "add",
        };
      }
      await this.$store.dispatch("updateConfig", updatePacket);
      this.toggleCreationActive();
      this.edit = {
        processing: false,
        automation: undefined,
        index: undefined,
      };
    },
  },
  created() {},
  components: {
    ItemTile,
    AutomationCreation,
    AutomationDelete,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #config-automations-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-items: flex-start;
    box-sizing: border-box;
  }

  .automation-item {
    margin: 20px;
    background-color: var(--secondaryColor);
  }
  @media (min-width: 800px) {
    .automation-item {
      margin: 30px;
    }
  }
}
</style>
